import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnknownproduct = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 5C7.6 5 6.4 6.1 6.4 7.5H7.7C7.7 6.8 8.3 6.2 9 6.2C9.7 6.2 10.3 6.8 10.3 7.5C10.3 8 10 8.3 9.5 8.6C8.7 9.1 8.4 9.6 8.4 10.6V11H9.6V10.7C9.6 10 9.8 9.7 10.4 9.3C11.1 8.8 11.6 8.3 11.6 7.5C11.6 6.1 10.4 5 9 5Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 12C9.55229 12 10 12.4477 10 13C10 13.5523 9.55229 14 9 14C8.44771 14 8 13.5523 8 13C8 12.4477 8.44771 12 9 12Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.29336 0.707011C8.65939 0.341266 9.23858 0.317687 9.63125 0.637675L9.70742 0.707011L17.2934 8.29295L17.3617 8.36814C17.6822 8.76092 17.6595 9.34181 17.2934 9.70799L9.70742 17.2939L9.63125 17.3613C9.26461 17.6605 8.73519 17.6605 8.36855 17.3613L8.29336 17.2939L0.706445 9.70799L0.638085 9.63084C0.339356 9.2642 0.339049 8.73461 0.638085 8.36814L0.706445 8.29295L8.29336 0.707011ZM1.41348 8.99998L8.99941 16.5859L16.5863 8.99998L9.00039 1.41404L1.41348 8.99998Z",
			fill: "black"
		})
	]
});
export default SvgUnknownproduct;
